const StatusIndicatorSuccess = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='8' height='45' viewBox='0 0 8 45'>
    <defs>
      <clipPath id='led-clip'>
        <rect width='8' height='45' rx='2' />
      </clipPath>
      <filter id='led-shadow' x='-50%' y='-50%' width='200%' height='200%'>
        <feDropShadow dx='0' dy='0' stdDeviation='3' floodColor='#22c55e' floodOpacity='0.6' />
      </filter>
    </defs>
    <g clipPath='url(#led-clip)'>
      <rect width='8' height='45' rx='2' fill='#22c55e' filter='url(#led-shadow)' />
      <rect
        x='0.5'
        y='0.5'
        width='7'
        height='44'
        rx='1.5'
        fill='none'
        stroke='#16a34a'
        strokeWidth='1'
        vectorEffect='non-scaling-stroke'
      />
    </g>
  </svg>
)

export { StatusIndicatorSuccess }
